module.exports = __webpack_public_path__ + "img/rank-achievement-bonus.9387967.webp";